<template>
  <!-- s::PAGE -->
  <div v-if="loading" class="loading"></div>

  <div v-else-if="error" class="error">{{ error.message }}</div>

  <div v-else class="contents">
    <!-- s:: MYPAGE -->
    <div class="mypage">
      <div class="layout">
        <div class="box">
          <div ref="sideRef" class="side-box">
            <div class="snb2">
              <ProfileSnb />
            </div>
          </div>
          <div class="content-panel">
            <div class="my-artartist">
              <div class="profile">
                <div class="title-wrap">
                  <h2 class="section-title">PROFILE</h2>
                </div>
                <form>
                  <div class="register">
                    <div class="picture-box">
                      <div class="img-wrap">
                        <ImageUploadPreview
                          :preview-image-file="previewImageFile"
                          @update:cropFile="
                            (val) => (selectedCropImageFile = val)
                          "
                          @update:originFile="
                            (val) => (selectedOriginImageFile = val)
                          "
                        />
                        <div class="txt-wrap">
                          <div class="txt-group">
                            <span>사진은 10MB 이하</span>
                            <span>PDF, JPG, PNG 형식</span>
                          </div>
                        </div>
                        <div class="notice-wrap">
                          <span>※ 아티스트 본인 사진을 권장하며,</span>
                          <span>부득이한 경우 아트워크 이미지로 대체할 수 있습니다.</span>
                        </div>
                      </div>
                    </div>
                    <div class="cont-box">
                      <ul>
                        <li>
                          <div class="title">
                            <span class="req">이름</span>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="sub-title">
                                <span>국문</span>
                              </div>
                              <div class="field">
                                <input
                                  type="text"
                                  v-model="artist.nameKo"
                                  maxlength="10"
                                  placeholder="키보드를 국문으로 설정 후 입력해주세요. (예: 홍길동)"
                                />
                              </div>
                            </div>
                            <div class="row">
                              <div class="sub-title">
                                <span>영문</span>
                              </div>
                              <div class="field">
                                <input
                                  type="text"
                                  v-model="artist.nameEn"
                                  maxlength="22"
                                  placeholder="키보드를 영문으로 설정 후 이름과 성 순으로 입력해주세요. (예: GILDONG HONG)"
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                        <ProfileEducation
                          ref="educationRef"
                          :data="artist.educations"
                          :is-no-education="
                            artist.imageUrl && artist.educations.length === 0
                          "
                        />
                        <ProfileExperience
                          ref="experienceRef"
                          :data="artist.experiences"
                        />

                        <li>
                          <div class="title">
                            <span class="req">활동 지역</span>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="sub-title">
                                <span>국내</span>
                              </div>
                              <div class="field">
                                <input
                                  type="text"
                                  v-model="artist.domesticArea"
                                  maxlength="200"
                                  placeholder="주요 활동 도시명을 적어주세요."
                                />
                              </div>
                            </div>
                            <div class="row">
                              <div class="sub-title">
                                <span>해외</span>
                              </div>
                              <div class="field">
                                <input
                                  type="text"
                                  v-model="artist.overseasArea"
                                  maxlength="200"
                                  placeholder="주요 활동 도시명을 적어주세요. (생략 가능)"
                                />
                              </div>
                            </div>
                          </div>
                          <button type="button" class="add-list no-text">
                            <img src="@/assets/images/icon/ico_add3.svg" alt=""/>
                          </button>
                        </li>

                        <li class="colspan">
                          <div class="title">
                            <span class="req">활동 장르(중복 가능)</span>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="field">
                                <div class="inner-list">
                                  <div class="li">
                                    <!-- 배포 후에도 칸 밀리면, 여기는 레이아웃이랑 css 수정 해야할듯  -->
                                    <div class="chk-group">
                                      <span
                                        v-for="genre in ARTIST_ACTIVITY_GENRES.slice(
                                          0,
                                          4
                                        )"
                                        :key="genre.value"
                                        class="checkbox-type1 chk-one"
                                        :class="genre.value === 'ETC' ? '' : ''"
                                      >
                                        <input
                                          type="checkbox"
                                          :id="'chk1-' + genre.value"
                                          :value="genre.value"
                                          v-model="artist.activityGenreTypes"
                                        />
                                        <label :for="'chk1-' + genre.value">{{
                                          genre.label
                                        }}</label>
                                        <input
                                          type="text"
                                          class="etc chk-etc-input"
                                          placeholder="(직접 입력)"
                                          v-model="artist.activityGenreEtc"
                                          maxlength="200"
                                          v-if="
                                            genre.value === 'ETC' &&
                                            artist.activityGenreTypes.includes(
                                              'ETC'
                                            )
                                          "
                                        />
                                      </span>
                                    </div>
                                    <div class="chk-group">
                                      <span
                                        v-for="genre in ARTIST_ACTIVITY_GENRES.slice(
                                          4
                                        )"
                                        :key="genre.value"
                                        class="checkbox-type1 chk-one"
                                        :class="
                                          genre.value === 'ETC' ? 'chk-etc' : ''
                                        "
                                      >
                                        <input
                                          type="checkbox"
                                          :id="'chk1-' + genre.value"
                                          :value="genre.value"
                                          v-model="artist.activityGenreTypes"
                                        />
                                        <label :for="'chk1-' + genre.value">{{
                                          genre.label
                                        }}</label>
                                        <input
                                          type="text"
                                          class="chk-etc-input"
                                          placeholder="(직접 입력)"
                                          v-model="artist.activityGenreEtc"
                                          maxlength="200"
                                          v-if="
                                            genre.value === 'ETC' &&
                                            artist.activityGenreTypes.includes(
                                              'ETC'
                                            )
                                          "
                                        />
                                      </span>
                                    </div>
                                    <!-- <span><input type="text" class="etc chk-etc-input" placeholder="(직접 입력)"
                                        v-model="artist.activityGenreEtc"
                                        v-if="artist.activityGenreTypes && artist.activityGenreTypes.includes('ETC')"></span> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <!-- 수상 -->
                        <li class="colspan">
                          <ProfileAward
                            ref="awardRef"
                            title="수상 내역"
                            placeholder="수상내역을 적어주세요."
                            :data="artist.awards"
                          />
                        </li>
                        <!-- 작품소장 -->
                        <li class="colspan">
                          <ProfileInput
                            ref="collectionRef"
                            title="작품 소장 내역"
                            placeholder="작품이 소장된 기관 또는 장소가 있다면 적어주세요."
                            :data="artist.collections"
                          />
                        </li>
                        <li class="colspan">
                          <div class="title">
                            <span class="req">아티스트 한 줄 소개</span>
                          </div>
                          <div class="col field style-04">
                            <div class="row">
                              <div class="field-one input-text-1 no-line">
                                <input
                                  type="text"
                                  maxlength="40"
                                  placeholder="프로필에 들어갈 문구입니다. 자유롭게 적어주세요.(40자 이내)"
                                  v-model="artist.introduction"
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="colspan">
                          <ProfileInterview
                            ref="interviewRef"
                            title="인터뷰 링크"
                            placeholder="인터뷰 기사 링크가 있다면 넣어주세요."
                            :data="artist.interviews"
                          />
                        </li>
                        <li class="colspan">
                          <div class="title">
                            <span>동영상 링크</span>
                          </div>
                          <div class="col field style-04">
                            <div class="row">
                              <div class="field-one input-text-1 no-line">
                                <input
                                  type="text"
                                  placeholder="작품 영상이 있다면 링크를 넣어주세요. 하나의 영상만 재생 가능합니다.(리스트 불가)"
                                  v-model="artist.videoLink"
                                  @input="validateVideoLink"
                                  maxlength="255"
                                  :style="{
                                    color: isValidVideoLink ? 'inherit' : 'red',
                                  }"
                                />
                              </div>
                            </div>
                            <!-- <p v-if="artist.videoLink && !isValidVideoLink" style="color: red;">
                              링크를 확인해주세요.
                            </p> -->
                          </div>
                        </li>
                        <li class="colspan">
                          <div class="title">
                            <span
                              >작가 노트<br />
                              <p style="font-size: 13px; color: #fff">
                                ({{ charCount }} / {{ maxLength }} 자)
                              </p></span
                            >
                          </div>
                          <div class="col field style-04">
                            <div class="row">
                              <div
                                class="field-one input-text-1 no-line artist-note-wrap"
                              >
                                <textarea
                                  name=""
                                  id=""
                                  v-model="artist.artistNote"
                                  :maxlength="maxLength"
                                  style="
                                    resize: none;
                                    width: 100%;
                                    font-size: 16px;
                                    background: none;
                                    border: none;
                                    height: 300px;
                                  "
                                  :placeholder="artistNotePlaceholder"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div class="button-box">
                        <!--                        <button type="button" @click="reload" style="margin-right: 10px;">취소하기</button>-->
                        <button type="button" @click="saveProfile">
                          저장하기
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- e:: MYPAGE -->
  </div>
  <!-- e::PAGE -->
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import "swiper/swiper-bundle.css";
import { apiClient } from "@/services/auth-header";
import ProfileSnb from "@/components/snb/MypageSnb.vue";
import ProfileEducation from "@/components/profile/ProfileEducation.vue";
import ProfileInput from "@/components/profile/ProfileInput.vue";
import ProfileExperience from "@/components/profile/ProfileExperience.vue";
import ProfileAward from "@/components/profile/ProfileAward.vue";
import { ARTIST_ACTIVITY_GENRES, USER_ROLE } from "@/common/common-enum";
import ImageCropper from "@/components/ui/ImageCropper.vue";
import { useUiStore } from "@/store/useUiStore";
import { useAuthStore } from "@/store/auth.module";
import ProfileInterview from "@/components/profile/ProfileInterview.vue";
import ImageUploadPreview from "@/components/ui/ImageUploadPreview.vue";

const uiStore = useUiStore();
const authStore = useAuthStore();

// 상태 변수 선언
const error = ref(null);
const loading = ref(true);

const sideRef = ref(null);
const educationRef = ref(null);
const experienceRef = ref(null);
const awardRef = ref(null);
const collectionRef = ref(null);
const interviewRef = ref(null);

const artist = ref({});
const previewImageFile = ref(null);
const selectedCropImageFile = ref(null);
const selectedOriginImageFile = ref(null);

const maxLength = 1200;
const charCount = computed(() => artist.value?.artistNote?.length || 0);
const artistNotePlaceholder =
  "포트폴리오 제작 시, 사용되는 작가 노트입니다.\n자유롭게 당신의 작품 세계에 대해 작성해주세요.(최대 1200자).";
const reload = () => {
  window.location.reload();
};

const koreanRegex = /^[가-힣]*$/; // 한글만 허용
const englishRegex = /^[A-Z ]*$/;
const noEnglishRegex = /[^A-Za-z]/g;
const koreanNumberRegex = /^[가-힣0-9]*$/; // 한글 + 숫자 허용
const englishNumberRegex = /^[A-Za-z0-9]*$/; // 영문 대소문자 + 숫자 허용

watch(
  () => artist.value.nameKo,
  (newVal) => {
    if (newVal?.length > 1 && !koreanRegex.test(newVal)) {
      artist.value.nameKo = newVal.replace(/[^가-힣]/g, "");
    }
  }
);

watch(
  () => artist.value.nameEn,
  (newVal) => {
    if (newVal?.length > 1 && !englishRegex.test(newVal)) {
      artist.value.nameEn = newVal.replace(/[^A-Za-z ]/g, "").toUpperCase();
    }
  }
);

watch(
  () => artist.value.domesticArea,
  (newVal) => {
    if (newVal?.length > 1) {
      artist.value.domesticArea = newVal.replace(/[A-Za-z]/g, "");
    }
  }
);

const isValidVideoLink = ref(true);

const validateVideoLink = () => {
  try {
    const url = new URL(artist.value.videoLink);
    isValidVideoLink.value = true; // 유효성 검사 로직 추가
  } catch (error) {
    isValidVideoLink.value = false;
  }
};

// 데이터 로드 및 초기화
const loadData = async () => {
  try {
    uiStore.showLoading();
    
    // ARTIST_BEFORE_PROFILE인 경우 role 갱신 시도
    if (authStore.status.user?.roleType === USER_ROLE.ARTIST_BEFORE_PROFILE) {
      await authStore.refreshRoleType();
    }
    
    const response = await apiClient.get("/v1/artists/me");
    artist.value = response.data;
    previewImageFile.value = { url: artist.value.imageUrl };
    validateVideoLink();
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    loading.value = false;
    uiStore.hideLoading();
  }
};

const saveProfile = async () => {
  const isValid = await validateMandatory();
  if (!isValid) {
    uiStore.hideLoading();
    return;
  }

  if (confirm("저장 하시겠습니까?")) {
    uiStore.showLoading();
    const formData = new FormData();
    if (selectedCropImageFile.value) {
      formData.append("cropImage", selectedCropImageFile.value);
      formData.append("originImage", selectedOriginImageFile.value);
    }

    artist.value.educations = educationRef.value.getFilteredData();
    artist.value.experiences = experienceRef.value.getFilteredData();
    artist.value.awards = awardRef.value.getFilteredData();
    artist.value.collections = collectionRef.value.getFilteredData();
    artist.value.interviews = interviewRef.value.getData();
    formData.append(
      "reqDto",
      new Blob([JSON.stringify(artist.value)], { type: "application/json" })
    );
    try {
      const response = await apiClient.put("/v1/artists/me", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (authStore.status.user.roleType === USER_ROLE.ARTIST_BEFORE_PROFILE) {
        await authStore.refreshRoleType();
      }

      alert("저장 되었습니다.");
      location.reload();
    } catch (error) {
      console.error("Error saveProfile data:", error);
    } finally {
      uiStore.hideLoading();
    }
  }
};

const validateMandatory = async () => {
  if (!previewImageFile.value.url && !selectedOriginImageFile.value) {
    alert("사진을 등록해 주세요.");
    return false;
  }

  if (!artist.value.nameKo && !artist.value.nameEn) {
    alert("작가명을 입력해 주세요.");
    return false;
  }

  if (!educationRef.value.validateData().isValid) {
    alert(educationRef.value.validateData().errorMessage);
    return false;
  }

  if (!experienceRef.value.validateData().isValid) {
    alert(experienceRef.value.validateData().errorMessage);
    return false;
  }

  if (!artist.value.domesticArea && !artist.value.overseasArea) {
    alert("활동지역을 입력해 주세요.");
    return false;
  }

  if (
    !artist.value.activityGenreTypes ||
    artist.value.activityGenreTypes.length === 0
  ) {
    alert("활동 장르를 선택해 주세요.");
    return false;
  }

  if (
    artist.value.activityGenreTypes.includes("ETC") &&
    (!artist.value.activityGenreEtc ||
      artist.value.activityGenreEtc.trim() === "")
  ) {
    alert('활동 장르에서 "기타"를 선택하신 경우, 내용을 입력해 주세요.');
    return false;
  }

  if (!artist.value.introduction?.trim()) {
    alert("아티스트 한 줄 소개을 입력해 주세요.");
    return false;
  }

  // if (!awardRef.value.validateData().isValid) {
  //   alert(awardRef.value.validateData().errorMessage);
  //   return false;
  // }

  return true;
};

// 컴포넌트가 마운트되었을 때 데이터 로드
onMounted(() => {
  loadData();
});
</script>

<style scoped>
textarea::placeholder {
  color: #b7b7b7;
  font-size: 16px;
  font-weight: 400;
  opacity: 1; /* iOS Safari에서 연해지는 현상 방지 */
}
</style>
